<template>
  <div>
    <vs-row vs-w="12" class="px-2">
      <vs-col vs-w="5" class="task-main-info">
        <div class="cstm-unique-tab-text" v-if="fromWhere === 'createPage'">
          <h4 class="header-text"><b>Create Project</b></h4>
          <div class="flex px-2 my-4">
            <div class="md:w-2/3 w-full pr-4">
              <span>Project Name</span><span class="required"></span>
              <vs-input
                class="w-full"
                v-model="projectData.name"
                placeholder="Enter project name"
              />
              <!-- <small v-if="!projectData.name" style="color: red"
                >Required Field</small
              > -->
            </div>
            <div class="md:w-1/3 w-full">
              <span>Due Date</span>
              <flat-pickr
                class="cstm-datepicker w-full"
                v-model="projectData.due_date"
                placeholder="Select Date"
                :config="configdateTimePicker1"
                @input="ProjectDueDate"
              />
            </div>
          </div>
          <div class="w-full px-2 my-4">
            <span>Details</span>
            <vs-textarea
              class="mb-0"
              v-model="projectData.details"
              label="Enter Details"
            />
          </div>
          <div class="md:w-1/2 w-full px-2 my-4">
            <div class="person-holder">
              <div>
                <!-- <feather-icon icon="UserIcon" /> -->
                <span>Members</span><span class="required"></span>
              </div>
              <div class="cstm-inp flex-wrap">
                <span
                  class="task-cstm-badge flex items-center"
                  :key="index"
                  v-for="(person, index) in memberData"
                >
                  <img
                    v-if="person.picture != ''"
                    class="
                      person-img
                      rounded-full
                      shadow-md
                      cursor-pointer
                      block
                    "
                    :src="person.picture"
                  />
                  <img
                    v-if="person.picture == ''"
                    class="
                      person-img
                      rounded-full
                      shadow-md
                      cursor-pointer
                      block
                    "
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ person.first_name }} {{ person.last_name }}
                  <feather-icon
                    class="cursor-pointer"
                    icon="XIcon"
                    @click="closeSelectedProject('Member', index)"
                  />
                </span>
                <a
                  class="font-bold cursor-pointer"
                  @click="addMoreUser('Member')"
                  >+ Add More</a
                >
              </div>
            </div>
          </div>
          <div class="w-full px-2 my-4">
            <div class="person-holder">
              <div>
                <!-- <feather-icon icon="UserIcon" /> -->
                <span>Status Listing (Re-Order the status by dragging)</span
                ><span class="required"></span>
              </div>
              <div class="cstm-inp flex-wrap">
                <draggable
                  :list="allTaskStatus"
                  @change="statusLogProject"
                  class="w-full p-2 cursor-move"
                >
                  <span
                    v-for="(taskStatus, index) in allTaskStatus"
                    :key="index"
                    class="
                      task-cstm-badge
                      w-full
                      flex
                      items-center
                      justify-between
                      mx-0
                      my-2
                    "
                  >
                    <p>{{ taskStatus.name }}</p>
                    <div class="inline-flex flex-wrap">
                      <vs-button
                        color="warning"
                        @click="editItemFromStatus(index, taskStatus)"
                        icon-pack="feather"
                        icon="icon-edit"
                        type="flat"
                      ></vs-button>

                      <vs-button
                        color="danger"
                        @click="closeStatus(index)"
                        icon-pack="feather"
                        icon="icon-x"
                        type="flat"
                      ></vs-button>
                      <!-- <feather-icon
                      style="color: red;"
                      @click="closeStatus(index)"
                      class="cursor-pointer"
                      icon="XIcon"
                    /> -->
                    </div>
                  </span>
                </draggable>
                <a class="font-bold cursor-pointer" @click="statusActive = true"
                  >+ Add More</a
                >
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-w="7" class="task-main-info">
        <!-- Task creation with project form -->
        <div class="flex mb-2 pr-2">
          <h4 class="header-text ml-2"><b>Task</b></h4>
          <vs-button
            type="filled"
            class="ml-auto mr-2"
            icon-pack="feather"
            icon="icon-plus"
            size="small"
            @click="addNewTask"
          >
            New Task
          </vs-button>
          <vs-button
            type="border"
            icon-pack="feather"
            icon="icon-edit"
            size="small"
            @click="importActive = true"
          >
            Import
          </vs-button>
        </div>
        <div class="relative p-2 ml-2">
          <vs-card
            class="task-card"
            v-for="(task_detail, index) in all_task_details"
            :key="index"
          >
            <div
              v-if="fromWhere === 'createPage'"
              slot="header"
              class="flex justify-between items-center"
            >
              <h4 class="header-text">
                Task {{ all_task_details.length - index }}
              </h4>
              <vs-button
                icon-pack="feather"
                v-if="index !== 0"
                color="danger"
                @click="removeCard(index)"
                type="flat"
                icon="icon-trash-2"
              ></vs-button>
            </div>
            <div class="cstm-unique-tab-text">
              <div class="px-2">
                <div class="flex flex-wrap -mx-2">
                  <div class="w-full px-2 my-2">
                    <span>Task Name</span>
                    <vs-input
                      class="w-full"
                      placeholder="Enter Task Name"
                      v-model="task_detail.name"
                    />
                  </div>
                  <div
                    v-if="fromWhere === 'createPage' && selectedStatus === ''"
                    class="md:w-1/2 w-full px-2 my-2"
                  >
                    <span>Choose Status</span><span class="required"></span>
                    <v-select
                      :key="updateStat"
                      v-model="task_detail.projectStatusTag"
                      v-validate="'required'"
                      :reduce="(option) => option.name"
                      label="name"
                      name="name"
                      :options="allTaskStatus"
                      placeholder="Choose Status"
                      style="width: 100%"
                    />
                    <small
                      v-if="!task_detail.projectStatusTag"
                      style="color: red"
                      >Required Field</small
                    >
                  </div>
                  <div v-else class="md:w-1/2 w-full px-2 my-2">
                    <vs-input
                      class="w-full"
                      v-model="selectedStatus"
                      readOnly
                    />
                  </div>

                  <div class="md:w-1/2 w-full px-2 my-2">
                    <span>Choose Priority</span>
                    <v-select
                      v-model="task_detail.task_priority_id"
                      v-validate="'required'"
                      :reduce="(option) => option.id"
                      label="level"
                      name="level"
                      :options="priority"
                      placeholder="Choose Priority"
                      style="width: 100%"
                    />
                  </div>
                  <div class="w-full px-2 my-2">
                    <span>Details</span>
                    <vs-textarea
                      class="mb-0"
                      label="Enter Details"
                      v-model="task_detail.details"
                    />
                  </div>
                  <div class="md:w-1/2 w-full px-2 my-2">
                    <div class="person-holder">
                      <div>
                        <!-- <feather-icon icon="UserIcon" /> -->
                        <span>Responsible Person</span>
                      </div>
                      <div class="cstm-inp flex-wrap">
                        <span
                          class="task-cstm-badge flex items-center"
                          :key="index1"
                          v-for="(
                            person, index1
                          ) in task_detail.ResponsiblePersonData"
                        >
                          <img
                            v-if="person.picture != ''"
                            class="
                              person-img
                              rounded-full
                              shadow-md
                              cursor-pointer
                              block
                            "
                            :src="person.picture"
                          />
                          <img
                            v-if="person.picture == ''"
                            class="
                              person-img
                              rounded-full
                              shadow-md
                              cursor-pointer
                              block
                            "
                            src="@/assets/images/pages/user-circle-solid.svg"
                          />
                          {{ person.first_name }} {{ person.last_name }}
                          <feather-icon
                            class="cursor-pointer"
                            icon="XIcon"
                            @click="
                              closeSelectedProject(
                                'ResponsiblePerson',
                                index,
                                index1
                              )
                            "
                          />
                        </span>
                        <a
                          v-if="task_detail.ResponsiblePersonData.length == 0"
                          class="font-bold cursor-pointer"
                          @click="
                            addMoreUserProject('ResponsiblePerson', index)
                          "
                          >+ Add More</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="md:w-1/2 w-full px-2 my-2">
                    <span>Deadline</span>
                    <flat-pickr
                      class="cstm-datepicker w-full"
                      v-model="task_detail.due_date"
                      placeholder="Select Date"
                      @input="ProjectUpdateCalendar(index)"
                      :config="task_detail.configdateTimePicker2"
                    />
                  </div>
                  <vs-divider />

                  <vs-tabs class="inner-tab task-info-tabs">
                    <vs-tab
                      label="Checklist"
                      icon-pack="feather"
                      icon="icon-list"
                    >
                      <div
                        :key="index3"
                        v-for="(checklistRow, index3) in checklistRows"
                      >
                        <div class="md:flex flex-nowrap items-center">
                          <vs-input
                            label="Checklist Name"
                            placeholder="Enter checklist name"
                            v-model="checklistRow.name"
                            style="width: 100%"
                          />
                        </div>

                        <!-- <ul class="checklist-ul task-checklist mb-4 m-0">
                            <draggable
                              :list="checklistRow.items"
                              @change="statusLog"
                              class="w-full p-2"
                              handle=".handle1"
                            >
                              <li
                                class="flex justify-between"
                                :key="index6"
                                v-for="(item, index6) in checklistRow.items"
                              >
                                <div class="flex items-center">
                                  <span
                                    class="
                                      material-icons-outlined
                                      simple_drag_icon
                                      handle1
                                    "
                                    >drag_indicator</span
                                  >
                                  <vs-checkbox
                                    v-model="item.is_completed"
                                    @change="
                                      changeStatusFromCheck(index3, index6)
                                    "
                                  ></vs-checkbox>
                                  <span v-html="replaceURLs(item.todo)"></span>
                                </div>
                                <div class="flex">
                                  <vs-button
                                    color="warning"
                                    @click="
                                      editItemFromCheck(index3, index6, item)
                                    "
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    type="flat"
                                  ></vs-button>
                                  <vs-button
                                    color="danger"
                                    @click="deleteItemFromCheck(index3, index6)"
                                    icon-pack="feather"
                                    icon="icon-trash-2"
                                    type="flat"
                                  ></vs-button>
                                </div>
                              </li>
                            </draggable>
                          </ul> -->
                        <div
                          class="checklist-item-list"
                          v-if="checklistRow.showTextBox.length"
                        >
                          <div
                            class="flex justify-between mt-4"
                            :key="index2"
                            v-for="(
                              testBox, index2
                            ) in checklistRow.showTextBox"
                          >
                            <span class="material-icons">drag_indicator</span>
                            <vs-input
                              class="inputx w-full"
                              placeholder="Type and enter to create item"
                              v-model="testBox.itemName"
                              @keyup.native.enter="
                                submitItem(index3, checklistRow)
                              "
                            />
                            <vs-button
                              color="danger"
                              icon-pack="feather"
                              icon="icon-trash-2"
                              type="flat"
                              @click="removeItem(checklistRow, index2)"
                            ></vs-button>
                          </div>
                        </div>
                        <div
                          class="flex flex-wrap justify-between items-center"
                        >
                          <a
                            style="padding-bottom: 2px"
                            class="cursor-pointer"
                            @click="addItem(checklistRow)"
                            >+ Add Item</a
                          >
                          <!-- <vs-button  @click="addItem(checklistRow)">+ Item</vs-button> -->
                          <a
                            style="color: #ea5455"
                            class="cursor-pointer"
                            @click="removeChecklist(index3)"
                            type="flat"
                            >Remove All</a
                          >
                        </div>
                        <vs-divider />
                      </div>
                      <vs-button class="p-2" @click="addChecklist"
                        >+ Add Checklist</vs-button
                      >
                    </vs-tab>
                    <vs-tab
                      label="Created By"
                      icon-pack="feather"
                      icon="icon-users"
                    >
                      <vs-input
                        v-if="userInfo.last_name === null"
                        label="Created By"
                        class="w-full mb-3"
                        :value="userInfo.first_name"
                        readonly
                      />
                      <vs-input
                        v-else
                        label="Created By"
                        class="w-full mb-3"
                        :value="userInfo.first_name + ' ' + userInfo.last_name"
                        readonly
                      />
                      <div class="mb-3">
                        <label for="" class="vs-input--label"
                          >Participants</label
                        >
                        <div class="flex flex-wrap">
                          <div class="cstm-inp flex-wrap">
                            <span
                              class="task-cstm-badge flex items-center"
                              :key="index4"
                              v-for="(person, index4) in participantData"
                            >
                              <img
                                v-if="person.picture != ''"
                                class="
                                  person-img
                                  rounded-full
                                  shadow-md
                                  cursor-pointer
                                  block
                                "
                                :src="person.picture"
                              />
                              <img
                                v-if="person.picture == ''"
                                class="
                                  person-img
                                  rounded-full
                                  shadow-md
                                  cursor-pointer
                                  block
                                "
                                src="@/assets/images/pages/user-circle-solid.svg"
                              />
                              {{ person.first_name }} {{ person.last_name }}
                              <feather-icon
                                class="cursor-pointer"
                                icon="XIcon"
                                @click="closeSelected('Participants', index4)"
                              />
                            </span>
                            <a
                              class="font-bold cursor-pointer person-add-button"
                              @click="addMoreUser('Participants')"
                              >+ Add</a
                            >
                          </div>
                        </div>
                      </div>
                      <div>
                        <label for="" class="vs-input--label">Observers</label>
                        <div class="flex flex-wrap">
                          <div class="cstm-inp flex-wrap">
                            <span
                              class="task-cstm-badge flex items-center"
                              :key="index4"
                              v-for="(person, index4) in observerData"
                            >
                              <img
                                v-if="person.picture != ''"
                                class="
                                  person-img
                                  rounded-full
                                  shadow-md
                                  cursor-pointer
                                  block
                                "
                                :src="person.picture"
                              />
                              <img
                                v-if="person.picture == ''"
                                class="
                                  person-img
                                  rounded-full
                                  shadow-md
                                  cursor-pointer
                                  block
                                "
                                src="@/assets/images/pages/user-circle-solid.svg"
                              />
                              {{ person.first_name }} {{ person.last_name }}
                              <feather-icon
                                class="cursor-pointer"
                                icon="XIcon"
                                @click="closeSelected('Observers', index4)"
                              />
                            </span>
                            <a
                              class="font-bold cursor-pointer person-add-button"
                              @click="addMoreUser('Observers')"
                              >+ Add</a
                            >
                          </div>
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab
                      label="Time Planning"
                      icon-pack="feather"
                      icon="icon-clock"
                    >
                      <div class="flex">
                        <div class="md:w-1/2 w-full pr-4">
                          <label for="" class="vs-input--label"
                            >From Time</label
                          >
                          <div>
                            <flat-pickr
                              placeholder="Enter Time"
                              :config="configdateTimePicker"
                              v-model="taskData.from_time"
                              @on-close="checkWhenClose('from')"
                            />
                          </div>
                        </div>
                        <div class="md:w-1/2 w-full">
                          <label for="" class="vs-input--label">To Time</label>
                          <div>
                            <flat-pickr
                              :config="configdateTimePicker"
                              v-model="taskData.to_time"
                              placeholder="Enter Time"
                              @on-close="checkWhenClose('to')"
                              :disabled="taskData.from_time == ''"
                            />
                          </div>
                        </div>
                      </div>

                      <vs-checkbox
                        v-model="taskData.is_tracking_active"
                        class="mt-5 ml-0"
                        >Time Tracking</vs-checkbox
                      >
                    </vs-tab>

                    <vs-tab
                      label="Project"
                      icon-pack="feather"
                      icon="icon-grid"
                    >
                      <div class="mb-3">
                        <label for="" class="vs-input--label">Projects</label>
                        <div>
                          <v-select
                            v-model="taskData.project"
                            class="w-full"
                            :reduce="(option) => option.id"
                            label="name"
                            name="name"
                            :options="projectList"
                            placeholder="Select Project"
                            @open="onOpenProject"
                            @close="onCloseProject"
                          >
                            <template #list-footer>
                              <li
                                ref="loadProject"
                                class="loader"
                                v-show="projectListMeta.has_next"
                              >
                                Loading more project...
                              </li>
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="" class="vs-input--label"
                          >Remind about task</label
                        >
                        <div>
                          <div
                            class="flex w-full"
                            :key="index"
                            v-for="(item, index) in reminderTime"
                          >
                            <flat-pickr
                              class="w-full"
                              :config="configdateTimePicker1"
                              v-model="item.reminder_time"
                              placeholder="Choose Date & Time"
                            />
                            <vs-button
                              class="cursor-pointer font-semibold ml-1"
                              type="flat"
                              @click="removeReminder(index)"
                              icon-pack="feather"
                              icon="icon-x-circle"
                              color="danger"
                            ></vs-button>
                          </div>
                          <a
                            class="cursor-pointer font-semibold block mt-2"
                            @click="addReminder"
                            >+ Reminder</a
                          >
                        </div>
                      </div>
                      <div class="flex flex-wrap items-center mb-3">
                        <label for="" class="vs-input--label">CRM</label>
                        <div class="cstm-inp flex flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index8"
                            v-for="(crm, index8) in selectedCRMData"
                          >
                            {{ crm.lead_first_name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('CRM', index8)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer person-add-button"
                            @click="addModal('CRM')"
                            >+ Add</a
                          >
                        </div>
                      </div>
                      <div
                        class="flex flex-wrap items-center mb-3"
                        v-if="selectedProjectsData.length <= 1"
                      >
                        <label for="" class="vs-input--label">SubTask</label>
                        <div class="cstm-inp flex flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index8"
                            v-for="(task, index8) in selectedSubTaskData"
                          >
                            {{ task.name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('subTask', index8)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer person-add-button"
                            @click="addModal('subTask')"
                            >+ Add</a
                          >
                        </div>
                      </div>
                      <div>
                        <label for="" class="vs-input--label">Tags</label>
                        <div class="w-full">
                          <v-select
                            append-to-body
                            class="w-full"
                            label="name"
                            taggable
                            :reduce="(option) => option.id"
                            :create-option="
                              (option) => ({
                                id: option,
                                label: option,
                                name: option
                              })
                            "
                            :options="tagsList"
                            v-model="taskData.tags"
                            :clearable="false"
                            data-vv-name="name"
                            name="name"
                            multiple
                            placeholder="Type and Enter"
                          >
                          </v-select>
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab label="Notes" icon-pack="feather" icon="icon-file">
                      <editor
                        :api-key="tinyMceApi"
                        v-model="taskData.comments"
                        :init="initializeTinyMce"
                      />
                    </vs-tab>
                  </vs-tabs>
                  <vs-divider />
                  <div
                    v-if="task_detail.is_template === false"
                    class="md:w-1/2 w-full px-2 my-2"
                  >
                    <vs-checkbox v-model="task_detail.is_template" vs-value="1"
                      >Save this as a template</vs-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
          <!-- right most action sidebar -->
          <div v-if="fromWhere === 'createPage'" class="fixed-actionbar">
            <a @click.prevent="addNewTask" class="block">
              <vs-tooltip
                text="Add New Task"
                position="right"
                class="option-tooltip"
              >
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 27.88 27.88"
                >
                  <circle
                    cx="13.94"
                    cy="13.94"
                    r="12.94"
                    class="cls-1"
                  ></circle>
                  <line
                    x1="13.94"
                    y1="8.45"
                    x2="13.94"
                    y2="19.43"
                    class="cls-1"
                  ></line>
                  <line
                    x1="8.45"
                    y1="13.94"
                    x2="19.43"
                    y2="13.94"
                    class="cls-1"
                  ></line>
                </svg>
              </vs-tooltip>
            </a>
            <a @click="importActive = true" class="block">
              <vs-tooltip text="Import" position="right" class="option-tooltip">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 24 24"
                  style="enable-background: new 0 0 24 24"
                  xml:space="preserve"
                >
                  <path
                    class="st0"
                    d="M4.78125,18.2910156v2.3330078c0,0.1975002,0.0800152,0.3906765,0.2196698,0.5303307   c0.1396542,0.1396542,0.332829,0.2196693,0.5303302,0.2196693h16.2841797c0.1975002,0,0.3906765-0.0800171,0.5303307-0.2196712   c0.1396523-0.1396542,0.2196674-0.3328285,0.2196674-0.5303288V3.3759766c0-0.1975021-0.0800152-0.3906765-0.2196674-0.5303307   c-0.1396542-0.1396542-0.3328304-0.2196693-0.5303307-0.2196693H5.53125c-0.1975012,0-0.390676,0.0800152-0.5303302,0.2196693   C4.8612652,2.9853001,4.78125,3.1784744,4.78125,3.3759766v9.9404297c0,0.4142132,0.3357863,0.75,0.75,0.75   c0.4142132,0,0.75-0.3357868,0.75-0.75L6.2812495,4.1259747h14.7841778v15.7480488H6.281249l0.0000005-1.5830078   c0-0.4142132-0.3357863-0.75-0.7499995-0.75c-0.4142137,0-0.7499995,0.3357868-0.7499995,0.75H4.78125z"
                  />
                  <path
                    class="st0"
                    d="M8.9902344,7.3354492h9.3896484c0.4142132,0,0.75-0.3357868,0.75-0.75c0-0.4142151-0.3357868-0.75-0.75-0.75   H8.9902344c-0.4142141,0-0.75,0.3357849-0.75,0.75C8.2402344,6.9996624,8.5760202,7.3354492,8.9902344,7.3354492"
                  />
                  <path
                    class="st0"
                    d="M8.9902344,10.0576172h5.5429688c0.4142132,0,0.75-0.3357868,0.75-0.75c0-0.4142141-0.3357868-0.75-0.75-0.75   H8.9902344c-0.4142141,0-0.75,0.3357859-0.75,0.75C8.2402344,9.7218304,8.5760202,10.0576172,8.9902344,10.0576172"
                  />
                  <path
                    class="st0"
                    d="M2.1845703,16.8632813h9.3891602c0.4142132,0,0.75-0.3357868,0.75-0.75c0-0.4142141-0.3357868-0.75-0.75-0.75   H2.1845703c-0.4142137,0-0.75,0.3357859-0.75,0.75C1.4345703,16.5274944,1.7703567,16.8632813,2.1845703,16.8632813"
                  />
                  <path
                    class="st0"
                    d="M8.3588734,13.4722681l2.4168472,2.4164467l-2.4168911,2.4168921   c-0.2928934,0.2928944-0.2928934,0.7677689,0,1.0606613s0.7677679,0.2928925,1.0606613,0l3.4776392-3.4776421L9.419446,12.41152   c-0.2929182-0.2928696-0.7677917-0.2928295-1.0606604,0.0000887c-0.2928696,0.2929173-0.2928295,0.7677908,0.0000887,1.0606604   L8.3588734,13.4722681z"
                  />
                </svg>
              </vs-tooltip>
            </a>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div class="my-2 text-right">
      <vs-button
        :disabled="!buttonProjectActive"
        v-if="project_id && projectIdForAddTask === ''"
        class="mx-2"
        @click="updateProject"
        >Update</vs-button
      >
      <vs-button
        :disabled="!buttonProjectActive"
        v-if="!project_id && projectIdForAddTask === ''"
        class="mx-2"
        @click="submitProject"
        >Save</vs-button
      >
      <vs-button
        v-if="fromWhere === 'projectDetailsPage' && projectIdForAddTask !== ''"
        :disabled="!buttonProjectActiveForSingle"
        class="mx-2"
        @click="submitTaskFromProject(projectIdForAddTask, selectedStatus)"
        >Save</vs-button
      >
    </div>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Responsible Person"
      :active.sync="popupresponse"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="currentPageUser == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedUsers" :data="userList">
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!--   <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="currentPageClient == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedClients" :data="clientList">
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUserProjectResponsible"
        >Add</vs-button
      >
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupActive"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="currentPageUser == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedUsers" :data="userList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="currentPageClient == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedClients" :data="clientList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUserProject">Add</vs-button>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Edit Item"
      :active.sync="projectChecklistEditPopup"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItemProjectForCheck()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Edit Item"
      :active.sync="projectChecklistEditPopup2"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItemProject()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      class="holamundo"
      :title="
        modalType == 'update' ? 'Update Status Field' : 'Add Status Field'
      "
      :active.sync="statusActive"
    >
      <vs-input
        class="w-full"
        placeholder="Status Field"
        v-model="statusname"
      />
      <vs-button
        v-if="this.statusname !== '' && modalType == 'create'"
        @click="addTaskStatus"
        class="float-right mt-4"
        >Add</vs-button
      >
      <vs-button
        v-if="this.statusname !== '' && modalType == 'update'"
        @click="updateTaskStatus"
        class="float-right mt-4"
        >Update</vs-button
      >
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Import Task"
      :active.sync="importActive"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Live Tasks">
          <div>
            <vs-table
              multiple
              class="import-table"
              v-model="selected"
              :data="liveTaskImportData"
            >
              <template slot="thead">
                <vs-th>Reference Id</vs-th>
                <vs-th>Task Name</vs-th>
                <vs-th>Task Details</vs-th>
                <vs-th>Deadline</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].reference_id">
                    {{ data[indextr].reference_id }}
                  </vs-td>
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].details">
                    {{ data[indextr].details }}
                  </vs-td>

                  <vs-td :data="data[indextr].due_date">
                    {{ data[indextr].due_date }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!-- <vs-button
              v-if="meta.has_next"
              @click="loadMoreTask('plus')"
              style="float: right"
              >Load More</vs-button
            >
            <vs-button
              v-if="meta.current_page > 1"
              @click="loadMoreTask('minus')"
              style="float: right"
              >Back</vs-button
            > -->
          </div>
        </vs-tab>
        <vs-tab label="Templates">
          <div>
            <vs-table
              multiple
              class="import-table"
              v-model="selected"
              :data="ListOfTask"
            >
              <template slot="thead">
                <vs-th>Task Name</vs-th>
                <vs-th>Task Details</vs-th>
                <vs-th>Priority</vs-th>
                <vs-th>Created At</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].details">
                    {{ data[indextr].details }}
                  </vs-td>

                  <vs-td :data="data[indextr].task_priority.level">
                    {{ data[indextr].task_priority.level }}
                  </vs-td>

                  <vs-td :data="data[indextr].createdat">
                    {{ data[indextr].created_at }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              v-if="meta_template.has_next"
              @click="loadMoreTemplate('plus')"
              style="float: right"
              >Load More</vs-button
            >
            <vs-button
              v-if="meta_template.current_page > 1"
              @click="loadMoreTemplate('minus')"
              style="float: right"
              >Back</vs-button
            >
          </div>
        </vs-tab>
      </vs-tabs>
      <div class="flex flex-wrap justify-between items-center my-4">
        <vs-button
          type="border"
          v-if="meta.current_page > 1"
          @click="loadMoreTask('minus')"
          >Back</vs-button
        >
        <div
          class="text-right"
          :class="[meta.current_page > 1 ? '' : 'w-full']"
        >
          <vs-button
            class="mr-1"
            v-if="meta.has_next"
            @click="loadMoreTask('plus')"
            >Load More</vs-button
          >
          <vs-button @click="exportToProject">Import</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add CRM"
      :active.sync="popupActiveCRM"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="CRM">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedCRM" :data="leadList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].lead_first_name">
                      {{ data[indextr].lead_first_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="leadMeta.current_page > 1"
                    @click="showCRM('minus')"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    v-if="leadMeta.has_next"
                    @click="showCRM('plus')"
                    icon-pack="feather"
                    icon="icon-chevron-right"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addProjMicData('CRM')"
        >Add</vs-button
      >
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Sub Task"
      :active.sync="popupActiveSubTask"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Sub Task">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedSubTask"
                :data="parentTaskData"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="sub_meta.current_page > 1"
                    @click="showSubTask('minus')"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    v-if="sub_meta.has_next"
                    @click="showSubTask('plus')"
                    icon-pack="feather"
                    icon="icon-chevron-right"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addProjMicData('subTask')"
        >Add</vs-button
      >
    </vs-popup>
    <div v-if="isBrowseContent">
      <vs-popup
        fullscreen
        title="Browse Item"
        :active.sync="isBrowseContent"
        class="childImportPopUp browse_modal_item"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="true"
        ></import-browse-files-model>
        <div slot="footer"></div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { TaskProject } from './mixins/task-project.js'
import Pagination from '@/components/common/pagination'
import { Project } from './mixins/project.js'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
export default {
  mixins: [TaskProject, Project, GoogleAuthorization],
  components: {
    Pagination,
    ImportBrowseFilesModel
  },
  props: ['project_id', 'fromWhere', 'projectIdForAddTask', 'selectedStatus'],
  computed: {
    buttonProjectActive () {
      console.log("Project", this.all_task_details)
      if (
        this.all_task_details.length !== 0 &&
        this.allTaskStatus.length !== 0 &&
        this.projectData.name !== '' &&
        this.memberData.length !== 0
      ) {
        if (this.all_task_details.length > 0) {
          this.all_task_details.forEach(task_details => {
            if (task_details.task_priority_id == "") return false
          })
          return true
        }
      } else {
        return false
      }
    },
    buttonProjectActiveForSingle () {
      if (
        this.all_task_details.length !== 0 &&
        this.all_task_details[0].ResponsiblePersonData.length !== 0 &&
        this.all_task_details[0].name !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    submitTaskFromProjectDetails () {
      this.$emit('hideTheAddTaskModal', true)
    }
  },
  async mounted () {
    this.file_repository_id = this.$store.getters.getRepoId
    this.userList = this.$store.getters.getGlobalUserList
    this.showButtonUser = this.$store.getters.getShowButtonUser
    this.currentPageUser = this.$store.getters.getCurrentPageUser
    this.currentPageClient = this.$store.getters.getcurrentPageClient
    this.clientList = this.$store.getters.getGlobalClientList
    this.showButtonClient = this.$store.getters.getShowButtonClient
    this.priority = this.$store.getters.getGlobalPriorityList
    this.tagsList = this.$store.getters.getGlobalTagList
    this.tag_meta = this.$store.getters.getTagMeta
    this.parentTaskData = this.$store.getters.getGlobalParentList
    this.sub_meta = this.$store.getters.getSubMeta
    this.ListOfTaskUpdate = this.$store.getters.getListOfTaskUpdate
    this.meta_template = this.$store.getters.getMetaTemplate
    this.ListOfLiveTaskUpdate = this.$store.getters.getListOfLiveTaskUpdate
    this.meta_task = this.$store.getters.getMetaTask
    this.ListOfProject = this.$store.getters.getListOfProject
    this.meta = this.$store.getters.getMeta
    this.leadList = this.$store.getters.getGlobalLeadList
    this.leadMeta = this.$store.getters.getLeadMeta
    const queryParams = this.$route.query || {}
    this.query_page.page = queryParams.page || 1
    this.query_page.limit = queryParams.limit || 20
    if (this.fromWhere !== 'projectDetailsPage') {
      this.fetchLiveTask(this.query_page.page)
      this.fetchTask(this.query_page)
      if (this.project_id !== '' && this.projectIdForAddTask === '') {
        this.showProject(this.project_id)
      }
    }
  }
}
</script>

<style>
.userModalStyle {
  z-index: 100000;
}

.task-card {
  background: #e6f5f6;
}
</style>